import * as types from './mutation-types'

const state = () => {
  return {
    darkMode: true,
    fragilePicked: [],
    probPicked: [],
    displayData : 0,
    externalData: null,
  externalSystem: null
  }
}

// getters
const getters = {
  darkMode: (state) => state.darkMode,
  fragilePicked: (state) => state.fragilePicked,
  probPicked: (state) => state.probPicked,
}

// actions
const actions = {
  setDarkMode({ commit }, darkMode) {
    commit(types.SET_DARK_MODE, { darkMode })
  },updateExternalData({ commit }, payload) {
    commit('SET_EXTERNAL_DATA', payload);
  }
}

// mutations
const mutations = {
  [types.SET_DARK_MODE](state, { darkMode }) {
    state.darkMode = darkMode
  },
  setFragilePicked(state, item) {
    state.fragilePicked = item;
  },
  setProbPicked(state, item) {
    state.probPicked = item;
  },
  setDisplayData(state, item) {
    state.displayData = item;
  },SET_EXTERNAL_DATA(state, payload) {
    state.externalSystem = payload.system;
    state.externalData = payload.data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
